import z from 'zod';
import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo } from 'react';

export const useFormResolver = <T>(
  schema: z.ZodSchema<T>,
) => {
  return useMemo(() => zodResolver(schema), [schema]);
}
